import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { httpClient } from '@s20/services/httpClient';
import { FormContext } from '../../../common/forms/FormElements';
import { getMappedFilterModel, ServerSideScrollRowsRequest } from '../../../common/dataGrid/DataGrid';
import { ApiRoutes } from '../../../Common';

// Widest date range the map will request, inclusive of both endpoints.
export const MAX_RANGE_DAYS = 14;

export const useJobQuery = () => {
    const { values } = useContext(FormContext);
    const {
        dispatchOfficeLocationId,

        // Daily Jobs View Map
        dateFrom, dateTo, jobNumber,
    } = values;

    const response = useQuery({
        queryKey: ['jobs', dispatchOfficeLocationId, dateFrom, dateTo, jobNumber],
        queryFn: () => {
            const filterModel = {};

            if (dispatchOfficeLocationId) {
                filterModel.DispatchCompanyId = {
                    value: dispatchOfficeLocationId,
                };
            }

            if (dateFrom && dateTo) {
                const mFrom = moment(dateFrom, 'YYYY-MM-DD');
                let mTo = moment(dateTo, 'YYYY-MM-DD');

                // hard cap at 2 weeks (14 days inclusive)
                const maxTo = mFrom.clone().add(MAX_RANGE_DAYS - 1, 'days');
                if (mTo.isAfter(maxTo)) {
                    mTo = maxTo;
                }

                filterModel.AssignmentDate = {
                    dateFrom: mFrom.format('YYYY-MM-DD HH:mm:ss'),
                    dateTo: mTo.format('YYYY-MM-DD HH:mm:ss'),
                    filterType: 'date',
                    type: 'inRange',
                    key: 'AssignmentDate',
                };
            }

            if (jobNumber) {
                filterModel.JobNumber = {
                    filterType: 'text',
                    type: 'contains',
                    filter: jobNumber,
                    key: 'JobNumber',
                };
            }

            const filterModelMapped = getMappedFilterModel(
                { ...filterModel },
                {},
            );

            const req = new ServerSideScrollRowsRequest();
            req.startRow = 0;
            req.endRow = 5000;
            req.filterModel = { ...filterModelMapped };
            req.sortModel = [];

            return httpClient.post(
                ApiRoutes.job.dailyView(),
                req,
            );
        },
        select: (result) => result?.rows || [],
    });

    return response;
};